export default __webpack_public_path__ + "static/media/OurBloggers3.52fe5e0a.png";